import { domain_backend } from 'const';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

function removeVietnameseAccents(str) {
    if (!str) return "";
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;";
}

function removeCookie(cname) {
    setCookie(cname, "")
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function createFormData(data, file_name) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
        if (value) {
            if (key === "file" && file_name) {
                formData.append(key, value, file_name);
                continue;
            }
            formData.append(key, value);
        }
    }
    return formData;
}

function sortObjectKeys(obj) {
    return Object.keys(obj).sort().reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
    }, {});
}

function formatTime(time, text = true) {
    const min = Math.floor(time / 60);
    var sec = time % 60;
    if (text) return `${min} phút ${sec} giây`
    sec = String(sec).padStart(2, '0');
    return `${min}:${sec}`
}

function searchItem(value, item, fields) {
    var v = removeVietnameseAccents(value.toLowerCase().trim());
    for (const field of fields) {
        if (removeVietnameseAccents(item[field]?.trim().toLowerCase()).includes(v)) {
            return true;
        }
    }
    return false
}

function formatVND(num) {
    const integer = Math.floor(num);
    return integer.toLocaleString('vi-VN');
}

function sum(arr) {
    return arr.reduce((partialSum, a) => partialSum + a, 0);
}

function correct_media(path) {
    try {
        const url = new URL(path);
        return (new URL(domain_backend).origin) + "/" + url.pathname.slice(1);
    } catch (TypeError) {
        return (new URL(domain_backend).origin) + "/" + path.slice(1);
    }
}

export {
    setCookie, removeCookie, getCookie, createFormData,
    sortObjectKeys, formatTime, searchItem, removeVietnameseAccents,
    formatVND, sum, correct_media
}